import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import VanyaLayout from "./component/VanyaLayout";
import AdminProductManager from "./Pages/ProductInventory";
import AdminOrders from "./Pages/AdminOrders";
import AdminDashboard from "./Pages/AdminDashboard";
import AdminContactPage from "./Pages/AdminContactPage";
import AddCouponForm from "./Pages/AdminCoupons";
import AdminLoginPage from "./Pages/AdminLoginPage";
import OnlinePaymentSettings from "./Pages/OnlinePaymentSettings";
import CollectionManagement from "./Pages/AdminCOllection";
import BannerManagement from "./Pages/BannerManagement";
import AdminShippingSettings from "./Pages/AdminShippingSettings";
import AdminSettingsPage from "./Pages/AdminSettingsPage";
import RazorpayCollections from "./Pages/RazorpayCollections";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Redirect root */}
        <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="login" element={<AdminLoginPage />} />

        {/* Admin layout */}
        <Route path="/admin" element={<VanyaLayout />}>
          
          {/* Default dashboard redirect */}
          <Route index element={<Navigate to="dashboard" replace />} />

          {/* Products page */}

          <Route path="products" element={<AdminProductManager />} />
                    <Route path="categories" element={<CollectionManagement/>} />
                    <Route path="banner" element={<BannerManagement/>} />

           <Route path="orders" element={<AdminOrders />} />
           <Route path="razorpay-collections" element={<RazorpayCollections />} />
            <Route path="dashboard" element={<AdminDashboard/>} />
             <Route path="contact" element={<AdminContactPage/>} />
           <Route path="coupons" element={<AddCouponForm/>} />
           <Route path="onlinepaymentssettings" element={<OnlinePaymentSettings/>} />
           <Route path="shipping" element={<AdminShippingSettings />} />
           <Route path="settings" element={<AdminSettingsPage />} />





        </Route>

        {/* 404 */}
        <Route path="*" element={<div>404 - Page Not Found</div>} />
      </Routes>
    </BrowserRouter>
  );
}